// Utilidades relacionadas con productos y suscripciones de Stripe

export const parseAmountFromString = (value) => {
  if (!value) return 0;
  if (typeof value === "number") return value;
  const match = String(value).match(/[\d.,]+/);
  if (!match) return 0;
  const normalized = match[0].replace(",", "");
  const parsed = parseFloat(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const normalizeSubscriptionProducts = (data) => {
  if (!Array.isArray(data)) return [];

  return data.map((item, index) => {
    const plans = Array.isArray(item.plans)
      ? item.plans.filter((plan) => plan?.active !== false)
      : [];
    const prices = {};

    plans.forEach((plan) => {
      const rawCycle = plan.billing_cycle || plan.cycle;
      const key =
        rawCycle === "year" || rawCycle === "yearly" ? "yearly" : "monthly";

      prices[key] = {
        ...plan,
        unit_amount: parseAmountFromString(plan.amount),
      };
    });

    return {
      ...item,
      id: item.id ?? index,
      name: item.subscription_name || item.name,
      prices,
    };
  });
};

export const isSubscriptionCancelled = (sub) => {
  if (!sub) return false;
  const status = (sub.status || "").toLowerCase();
  const stripeStatus = (sub.stripe_subscription?.status || "").toLowerCase();
  const isActiveFlag = sub.is_active;
  return (
    status === "canceled" ||
    status === "cancelled" ||
    stripeStatus === "canceled" ||
    stripeStatus === "cancelled" ||
    isActiveFlag === false
  );
};

// Importe base del producto (en USD) a partir de un Price
export const getPriceAmount = (priceObj) => {
  if (!priceObj) return 0;
  const rawAmount = priceObj.unit_amount ?? priceObj.price ?? priceObj.amount ?? 0;
  if (typeof rawAmount !== "number") return 0;
  if (rawAmount <= 0) return 0;
  // Los montos del backend ya vienen en unidades de moneda (por ejemplo "50.00 USD" -> 50),
  // por lo que no debemos dividir por 100 aquí.
  return rawAmount;
};

export const getPriceForBilling = (product, billing) => {
  const key = billing === "yearly" ? "yearly" : "monthly";

  // Formato recomendado: product.prices = { monthly: {..}, yearly: {..} }
  if (product.prices && product.prices[key]) return product.prices[key];

  // Formatos alternativos: monthly_price / yearly_price
  if (key === "monthly" && product.monthly_price) return product.monthly_price;
  if (key === "yearly" && product.yearly_price) return product.yearly_price;

  return null;
};

export const getAmountWithBilling = (product, billing) => {
  const price = getPriceForBilling(product, billing);
  if (price) return getPriceAmount(price);

  // Fallback: si por alguna razón solo viene un unit_amount + billing_cycle,
  // mantenemos la lógica de multiplicar por 10 para yearly.
  const base = getPriceAmount({
    unit_amount: product.unit_amount ?? product.price ?? product.amount ?? 0,
  });
  const multiplier = billing === "yearly" ? 10 : 1;
  return base * multiplier;
};

export const getSubscriptionActivePriceId = (sub) => {
  if (!sub) return null;
  return (
    sub?.stripe_subscription?.items?.data?.[0]?.price?.id ||
    sub?.stripe_subscription?.items?.[0]?.price?.id ||
    sub?.plan?.stripe_id ||
    sub?.plan?.id ||
    sub?.stripe_price_id ||
    sub?.price_stripe_id ||
    null
  );
};

export const productHasPriceId = (product, priceId) => {
  if (!product || !priceId) return false;
  const monthly = product?.prices?.monthly;
  const yearly = product?.prices?.yearly;
  const monthlyId = monthly?.stripe_id || monthly?.id || monthly?.price_stripe_id;
  const yearlyId = yearly?.stripe_id || yearly?.id || yearly?.price_stripe_id;
  return monthlyId === priceId || yearlyId === priceId;
};
